import React, { ReactElement } from "react";
import { Container } from "./style";

interface ITolltipsProps {
  title: string;
  classname?: string;
  children: ReactElement;
  type?: "success" | "error" | "info";
}

export const Tooltip: React.FC<ITolltipsProps> = ({
  title,
  classname = "",
  children,
  type = "info",
}) => {
  return (
    <Container type={type} className={classname}>
      {children}
      <span>{title}</span>
    </Container>
  );
};
